import type { ReactNode } from 'react'

import * as styles from './content-navigation-parent.styles'

type Props = {
  children: ReactNode
}

export const ContentNavigationParent = ({ children }: Props) => (
  <ul css={styles.list}>{children}</ul>
)
